module.exports = __webpack_public_path__ + "img/micon-5.f54ee58e.svg";